// extracted by mini-css-extract-plugin
export var askAiIcon = "_p8-9";
export var container = "_p8-0";
export var groupSeparator = "_p8-a";
export var highlight = "_p8-4";
export var resultIcon = "_p8-5";
export var resultItem = "_p8-7";
export var resultSubtitle = "_p8-3";
export var resultTitle = "_p8-2";
export var resultsList = "_p8-1";
export var searchGroup = "_p8-6";
export var selected = "_p8-8";